import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CardOperationsComponent } from "src/app/card-operations/card-operations.component";
import { userFavoritesResModel, virtualCardsResModel } from "../../../models/favoriteResponse.model";

interface IModalActions{
    openModal():void
    setInput?(input:string):void
}

abstract class AbstractModalActions implements IModalActions{
    modalRef!: NgbModalRef;
    constructor(protected modalService: NgbModal){}

    openModal():void{
        const modalRef = this.modalService.open(CardOperationsComponent);
    }

}

class AddToFavAction extends AbstractModalActions implements IModalActions{
    constructor(protected modalService: NgbModal){
        super(modalService);
    }

    openModal():void{
        this.modalRef = this.modalService.open(CardOperationsComponent);
        this.modalRef.componentInstance.modalType = 'AddtoFav';    
    }
}

class OnlineChargeAction extends AbstractModalActions implements IModalActions{
    constructor(protected modalService: NgbModal){
        super(modalService);
    }
    
    openModal():void{
        this.modalRef = this.modalService.open(CardOperationsComponent, {size: 'lg', animation: true, backdrop: 'static'});
        this.modalRef.componentInstance.modalType = 'OnlineCharge';
    }
}

class CardDetailAction extends AbstractModalActions implements IModalActions{
    constructor(protected modalService: NgbModal){
        super(modalService);
    }
    
    openModal():void{
        this.modalRef = this.modalService.open(CardOperationsComponent, {size: 'lg', animation: true, backdrop: 'static'});
        this.modalRef.componentInstance.modalType = 'CardDetail';
    }
}

class OnlineChargeFavAction extends AbstractModalActions implements IModalActions{    
    constructor(protected modalService: NgbModal){
        super(modalService);
    }
    
    openModal():void{
        this.modalRef = this.modalService.open(CardOperationsComponent, {size: 'lg', animation: true, backdrop: 'static'});
        this.modalRef.componentInstance.modalType = 'OnlineChargeFav';
    }
}

class ActionWithInput implements IModalActions {
    constructor(protected action: AbstractModalActions){}
    
    openModal():void{
        this.action.openModal();
    }

    setInput(input:string){
        this.action.modalRef.componentInstance.modalInput = input;
    }
}


export class ModalActionsFactory{
    constructor(private modalService: NgbModal){}

    getModalAction(modalType:string):IModalActions{
        if(modalType == 'AddtoFav'){
            return new AddToFavAction(this.modalService);
        }else if(modalType == 'OnlineCharge'){
            return new OnlineChargeAction(this.modalService);
        }else if(modalType == 'CardDetail'){
            const action = new CardDetailAction(this.modalService);
            return new ActionWithInput(action);
        }else if(modalType == 'OnlineChargeFav'){
            const action = new OnlineChargeFavAction(this.modalService);
            return new ActionWithInput(action);
        }else {
            throw new Error('unexpected modal action fired!')
        }
    }

}